import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateFilterAppliedValue, updateFilterAppliedLogic } from '../redux/slices/filtersSlice';
import useFilterUrl from './useFilterUrl';

const useUpdateFilterValue = () => {
	const dispatch = useDispatch();
	const { changeFilterURL, changeFilterLogic } = useFilterUrl();

	const updateFilterValue = useCallback(
		(cid, categoryId, newValue) => {
			dispatch(
				updateFilterAppliedValue({
					cid: cid,
					value: newValue,
					categoryId: categoryId
				})
			);
			changeFilterURL(cid, newValue);
		},
		[dispatch, changeFilterURL]
	);

	const updateFilterLogic = useCallback(
		(cid, logic) => {
			changeFilterLogic(cid, logic);
			dispatch(updateFilterAppliedLogic({ cid: cid, value: logic }));
		},
		[dispatch, changeFilterLogic]
	);

	return { updateFilterValue, updateFilterLogic };
};

export default useUpdateFilterValue;
